import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
    UrlTree
} from '@angular/router';
import { Store } from '@ngrx/store';
import { RoleRestrictions } from 'app/entities';
import { AuthService } from 'app/services/auth.service';
import { selectUser } from 'app/state/user/user.select';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  constructor(
    private store:Store,
    private _router: Router,
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.store.select(selectUser).pipe(
      filter((user) => (user!=null && route.data.module)),
      map((user) => {
        const restrictions: string[] = RoleRestrictions[user!.roleName] || [];
        if (restrictions.indexOf(route.data.module) > -1) {
          this._router.navigate(['/dashboard'])
          // return false;
        }
        return true;
      })
    );
  }
}